var _defs, _path, _path2, _rect, _rect2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#214080;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.51,10.14c2.71-.1,4.34-1.99,4.64-2.36l.26-.33-.29-.31c-.44-.48-2.07-2.06-4.62-2.15-2.87-.09-4.72,1.77-5.06,2.15l-.29,.31,.27,.33c.32,.4,2.03,2.37,4.86,2.37,.07,0,.15,0,.22,0Zm-.03-4.16c1.75,.06,2.99,.95,3.59,1.51-.56,.57-1.79,1.59-3.6,1.65-2.02,.08-3.38-1.06-3.96-1.65,.63-.57,2.04-1.57,3.96-1.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.64,7.55c0-.74-.61-1.35-1.35-1.35s-1.35,.61-1.35,1.35,.61,1.35,1.35,1.35,1.35-.61,1.35-1.35Zm-1.35,.35c-.19,0-.35-.16-.35-.35s.16-.35,.35-.35,.35,.16,.35,.35-.16,.35-.35,.35Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.97,
    y: 3.32,
    width: 6.55,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.88,
    y: 10.76,
    width: 6.55,
    height: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.64,17.15l-3.98-3.97c-.21-.21-.5-.34-.8-.32-.3,0-.58,.13-.79,.34l-.12,.13-1.3-1.29c1.09-1.27,1.75-2.91,1.75-4.7C14.39,3.35,11.15,.1,7.16,.1S-.08,3.35-.08,7.34s3.25,7.24,7.24,7.24c1.83,0,3.51-.69,4.78-1.82l1.32,1.3-.17,.17c-.42,.44-.4,1.14,.03,1.56l4,3.89c.21,.21,.5,.31,.78,.31s.57-.11,.78-.32l.96-.95c.21-.21,.33-.49,.33-.79,0-.3-.11-.58-.33-.79ZM.92,7.34C.92,3.9,3.72,1.1,7.16,1.1s6.24,2.8,6.24,6.24-2.8,6.24-6.24,6.24S.92,10.77,.92,7.34Zm18.01,10.68l-.96,.95s-.11,.04-.15,0l-4-3.89s-.05-.11,0-.15l.98-1.03h.16s3.98,3.97,3.98,3.97l.35-.35-.35,.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.501ba7a0372607c9c5aa91c1558063cb.svg";
export { ForwardRef as ReactComponent };